export default "__VITE_ASSET__DdYFeDbF__"